import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        licencePeriod: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'licence.Licence period' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <manage-settings-licences-periods-form form="vm.form"/>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li class="primary" ng-if="vm.isDeleteAllowed()"><button class="btn negative" type="button" ng-click="vm.delete()">{{ 'general.Delete' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, FormFactory, ModalService, LicenceResource, LicencePeriodResource) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.form = FormFactory.createFromResource(this.licencePeriod);
        this.ModalService = ModalService;
        this.LicenceResource = LicenceResource;
        this.LicencePeriodResource = LicencePeriodResource;
    }

    $onInit () {
        this.oldPointsPerPeriod = angular.copy(this.licencePeriod.pointsPerPeriod);
    }

    save () {
        if (this.oldPointsPerPeriod !== parseInt(this.form.model.pointsPerPeriod, 10)) {
            const message = this.$translate.instant('licence.points_changed_message');
            this.ModalService.confirm(message, 'medium').then(() => this.form.save().then((licencePeriod) => this.uibModalInstance.close(licencePeriod)));
        }
        else {
            this.form.save().then((licencePeriod) => this.uibModalInstance.close(licencePeriod));
        }
    }

    isDeleteAllowed () {
        const { licencePeriod } = this;
        const isInitialLicencePeriod = licencePeriod.initialLicencePeriod.id === licencePeriod.id;
        return !isInitialLicencePeriod && !licencePeriod.licencePoints.length;
    }

    delete () {
        return this.ModalService.delete(this.$translate.instant('licence.Are you sure you wish to delete the licence period?'))
            .then(() => {
                this.LicencePeriodResource.delete({ id: this.licencePeriod.id }).$promise
                    .then(() => {
                        this.toastr.success(this.$translate.instant('licence.Licence period deleted'));
                        this.uibModalInstance.close();
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/licences/edit/periods/edit/index.js